module.exports = __webpack_public_path__ + "static/media/footer-top-company-logo.99367cde.png";